import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/state/store';
import { cpaAPI } from '@samclick-static-urls';
import { sendGet, sendPost, sendPut } from '@samclick-api-client';
import Payload from './payload';
import { affiliateAPI } from "@/api-client/static-url-ua";
import { sendUAGet } from '@/api-client/unified-api';

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'cpa',
})
class CpacommissionStore extends VuexModule {
    cpacommissionStore: any = { ...this.init() }

    private init() {
        return {
            rewardPlans: [],
            loading: false,
            allocatedAffiliates: [],
        };
    }


  @Mutation
    SET_CPA_LOADING(loading: boolean) {
        this.cpacommissionStore.loading = loading;
    }

  @Mutation
  SET_REWARD_PLANS(response: any) {
      this.cpacommissionStore.rewardPlans = response || [];
  }

  @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_CPA_LOADING', show);
  }


  @Action({ rawError: true })
  getRewardPlans(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateAPI.getRewardPlans, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_REWARD_PLANS', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

    // @Action({ rawError: true })
    // revshareSearch(payload: Payload) {
    //   this.showLoader(payload.activateLoader);
    //   return new Promise((resolve, reject) => {
    //     sendGet(cpaAPI.getRevshareSearch, payload.data).then((response) => {
    //       if (payload.storeData) {
    //         this.context.commit('SET_REV_SHARE_LIST', response.data);
    //       }
    //       this.showLoader(false);
    //       resolve(response);
    //     }, (error) => {
    //       this.showLoader(false);
    //       reject(error.response);
    //     });
    //   });
    // }
}

export default getModule(CpacommissionStore);
